import { closeInvoicePayStripeDialog } from "../invoiceSlice";
import InvoiceStripePaymentShared from "../../Shared/StripePayment/InvoiceStripePaymentShared";
import { useQueryClient } from "@tanstack/react-query";
import { useClientPortalDispatch, useClientPortalSelector } from "../../../redux";
import { useSnackbar } from "@powerdiary/components-library/lib";
import { useClientPortalConfigContext } from "../../../context/ClientPortalConfig.ctx";
import { Box, Button } from "@mui/material";

const FORM_ID = "invoices-list-stripe-payment-form";

export default function InvoicesStripePayment() {
    const { invoiceStripePayment } = useClientPortalSelector((state) => state.invoice);
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useClientPortalDispatch();
    const { clientPortalGuid } = useClientPortalConfigContext();
    const queryClient = useQueryClient();

    const handleSuccessfulPayment = async () => {
        await queryClient.invalidateQueries({
            queryKey: [`/api/v1/${clientPortalGuid}/Invoices`],
        });

        dispatch(closeInvoicePayStripeDialog());

        enqueueSnackbar("Payment successful!", { variant: "success" });
    };

    return (
        <Box data-test-id="invoices_stripe_payment" sx={{ display: "flex", flexDirection: "column", gap: "24px" }}>
            <InvoiceStripePaymentShared
                {...invoiceStripePayment}
                formId={FORM_ID}
                onSuccessfulPayment={() => void handleSuccessfulPayment()}
            />
            <Button variant="contained" type="submit" size="large" form={FORM_ID} fullWidth>
                Pay Now
            </Button>
        </Box>
    );
}
